<template>
  <div class="main">
    <h1>ID: {{ room && room.id }}</h1>
    <table cellspacing="10">
      <tr>
        <td>№</td>
        <td>ID</td>
        <td>Название</td>
        <td>Участие</td>
        <td>Соединение</td>
        <!-- <td>Действие</td> -->
      </tr>
      <tr v-for="(value, name) in teams" v-bind:key="name">
        <td>{{ value.num }}</td>
        <td>{{ name }}</td>
        <td>{{ value.name }}</td>
        <td>
          <input
            type="checkbox"
            @change="check(name, $event)"
            v-model="value.canPress"
          />
        </td>
        <td>{{ value.connected ? "" : "ОТКЛЮЧЕН" }}</td>
        <!-- <td> -->
        <!-- <button>Выгнать</button> -->
        <!-- </td> -->
      </tr>
    </table>
    <div>
      <button v-if="!gameStarted" @click="start">Старт</button
      ><button v-if="gameStarted" @click="stop">Стоп</button
      ><button @click="cleanQueue">Сброс очереди</button>
    </div>
  </div>
</template>

<script>
import * as Colyseus from "colyseus.js";
import { mapGetters, mapState } from "vuex";

export default {
  name: "Game",
  data: () => {
    return {
      gameStarted: false,
      state: null,
      room: null,
      teams: {},
    };
  },
  computed: {
    ...mapGetters({
      reconnectId: "reconnectId",
    }),
  },
  components: {},
  methods: {
    check(teamId, data) {
      console.log(teamId, data.target.checked);
      if (this.$data.room)
        this.$data.room.send("setCanPress", {
          teamId: teamId,
          value: data.target.checked,
        });
    },
    start() {
      console.log("start");
      if (this.$data.room) this.$data.room.send("startGame", {});
    },
    stop() {
      console.log("stop");
      if (this.$data.room) this.$data.room.send("stopGame", {});
    },
    cleanQueue() {
      console.log("cleanQueue");
      if (this.$data.room) this.$data.room.send("cleanQueue", {});
    },
  },
  mounted: async function () {
    let client = new Colyseus.Client("wss://smartcity.ugscompany.ru/api");
    let reconnectId = this.reconnectId;
    let room;
    if (reconnectId) {
      this.$store.dispatch("saveReconnectData", { gameId: "" });
      this.$data.sessionId = localStorage.getItem("sessionId");
      if (this.$data.sessionId) {
        room = await client.reconnect("7777", this.$data.sessionId);
      } else {
        this.$router.push("/admin");
      }
    } else room = await client.joinOrCreate("smart_city_room", { admin: true });
    localStorage.setItem("sessionId", room.sessionId);
    this.$data.room = room;
    room.onStateChange((state) => {
      console.log("the room state has been updated:", state);

      this.$data.gameStarted = state.gameStarted;

      let teamsList = {};
      state.teams.forEach((value, key) => {
        let num = "";
        let teamIndex = state.pressQueue.indexOf(key);
        if (teamIndex >= 0) num = teamIndex + 1;
        value.num = num;
        teamsList[key] = value;
      });

      this.$data.teams = teamsList;
      console.log(teamsList);
    });
  },
};
</script>

<style scoped>
.main {
  display: flex;
  height: 100%;
  width: 100%;
  align-content: center;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

.main h1,
.main h2,
.main table {
  border: none;
  color: white;
  font-family: Avenir, Arial, sans-serif;
  font-weight: 900;
  text-shadow: 0 3px 1px rgba(122, 17, 8, 0.8);
  outline: none;
  text-align: center;
}

h1 {
  font-size: 3em;
  margin-bottom: 0;
  margin-top: 0.25em;
}

h2 {
  font-size: 2em;
  margin-bottom: 0;
  margin-top: 0.1em;
}
</style>